import Popover from '@mui/material/Popover';
import { Box } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import { ActionsContainer, ActionsOption } from './actions-container';

interface Props {
  open: boolean;
  options: ActionsOption[];
  anchor: HTMLElement | null;
  onClose: () => void;
  onClick: (value: string | number) => void;
  sx?: SystemStyleObject;
}

export function ActionsPopover({ open, options, anchor, onClose, onClick, sx }: Props) {
  const handleClick = (value: string | number) => {
    onClick(value);
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchor}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <Box p={1} sx={sx}>
        <ActionsContainer options={options} onClick={handleClick} />
      </Box>
    </Popover>
  );
}
